import type { FolderBreadcrumb } from '@/dc-shared-web/src/hooks/api/folder/types'
import type { ProjectNew } from '@/dc-shared-web/src/hooks/api/project'

export const getBreadcrumbItems = (
  folderOrProject: FolderBreadcrumb | ProjectNew | undefined | null,
  searchParams: URLSearchParams
) => {
  return (
    folderOrProject?.parent
      ?.sort((a, b) => b.level - a.level)
      .filter((item) => item.level !== 0)
      .map((item) => ({
        label: item.name,
        url: `/${item.type === 'folder' ? 'folders' : 'projects'}/${item.uuid}?${searchParams.toString()}`,
      })) || []
  )
}
